
// // const GeneralInfo = () => {
// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const { patientData, setPatientData } = usePatient();
// //   const [gender, setGender] = useState("");
// //   const [ethnicity, setEthnicity] = useState("");
// //   const [errors, setErrors] = useState({});
// //   const [isSubmitting, setIsSubmitting] = useState(false);
// //   const [isFormValid, setIsFormValid] = useState(false);

// //   const hasLoadedInitialData = useRef(false);

// //   // Load existing data when component mounts
// //   useEffect(() => {
// //     if (hasLoadedInitialData.current) {
// //       return;
// //     }
// //     hasLoadedInitialData.current = true;

// //     const loadPatientData = async () => {
// //       try {
// //         // Debug: Log what's available in location.state and patientData
// //         console.log("🔍 Location state:", location.state);
// //         console.log("🔍 Patient data from context:", patientData);

// //         // Check if we have prepopulated data from appointment details
// //         if (location.state?.patient) {
// //           const prepopulatedData = location.state.patient;
// //           console.log("🔍 Using prepopulated data:", prepopulatedData);

// //           // Update patient data in context with prepopulated data
// //           setPatientData(prepopulatedData);

// //           // Set form fields from prepopulated data
// //           setGender(prepopulatedData.gender || "");
// //           setEthnicity(prepopulatedData.ethnicity || "");
// //           return;
// //         }

// //         // Fallback to existing logic for API-based data loading
// //         const patientId = location.state?.patientId || patientData?.patientId;
// //         const encounterId =
// //           location.state?.encounterId || patientData?.encounterId;

// //         console.log("🔍 PatientId from state:", patientId);
// //         console.log("🔍 EncounterId from state:", encounterId);

// //         if (patientId) {
// //           console.log("🔍 Fetching patient data for ID:", patientId);

// //           const response = await fetchPatientById(patientId);
// //           console.log("📊 Patient data from API:", response);

// //           if (response) {
// //             setGender(response.gender || "");
// //             setEthnicity(response.ethnicity || "");
// //             setPatientData(response);
// //           }
// //         }
// //       } catch (error) {
// //         console.error("Error loading patient data:", error);
// //       }
// //     };

// //     loadPatientData();
// //   }, [location.state, patientData, setPatientData]);

// //   // Check form validity whenever gender or ethnicity changes
// //   useEffect(() => {
// //     const isValid = gender && ethnicity;
// //     setIsFormValid(isValid);
// //   }, [gender, ethnicity]);

// //   const validateForm = () => {
// //     const newErrors = {};

// //     if (!gender) {
// //       newErrors.gender = "Gender is required";
// //     }
// //     if (!ethnicity) {
// //       newErrors.ethnicity = "Ethnicity is required";
// //     }

// //     setErrors(newErrors);
// //     return Object.keys(newErrors).length === 0;
// //   };

// //   const handleContinue = async () => {
// //     if (!validateForm()) {
// //       return;
// //     }

// //     setIsSubmitting(true);

// //     try {
// //       const updates = {
// //         gender,
// //         ethnicity,
// //         generalInfoComplete: true,
// //       };

// //       let updatedPatientData;
// //       let patientId;

// //       // Check if this is a new patient or existing patient
// //       if (!patientData.patientId) {
// //         // Create new patient
// //         console.log("Creating new patient...");

// //         const newPatientData = {
// //           patientId: uuidv4(),
// //           firstName: patientData.firstName,
// //           lastName: patientData.lastName,
// //           birthDate: patientData.birthDate,
// //           email: patientData.email,
// //           gender,
// //           ethnicity,
// //           patientAccountNumber: patientData.ehrNumber,
// //           orderingPhysician: patientData.orderingPhysician,
// //           selectedStudies: patientData.selectedStudies,
// //           billingAccount: patientData.billingAccount,
// //           isDropIn: patientData.isDropIn || false,
// //           generalInfoComplete: true,
// //         };

// //         console.log("New patient data:", newPatientData);

// //         const createdPatient = await createPatient(newPatientData);
// //         console.log("Patient created successfully:", createdPatient);

// //         patientId = createdPatient.patientId || createdPatient.id;
// //         updatedPatientData = {
// //           ...patientData,
// //           ...createdPatient,
// //           ...updates,
// //         };
// //       } else {
// //         // Update existing patient
// //         console.log("Updating existing patient...");

// //         // Update patient data in context
// //         updatedPatientData = {
// //           ...patientData,
// //           ...updates,
// //         };

// //         console.log("Updating patient data:", updates);

// //         const patientPatchPayload = filterPatientPayload(updates);

// //         if (Object.keys(patientPatchPayload).length > 0) {
// //           await fetchAPI(
// //             `biobank/patients/${patientData.patientId}`,
// //             "PATCH",
// //             {},
// //             patientPatchPayload
// //           );
// //         }

// //         console.log("Patient data updated successfully");
// //         patientId = patientData.patientId;
// //       }

// //       // Update patient data in context
// //       setPatientData(updatedPatientData);

// //       // Decide next step in flow
// //       const encounterId =
// //         location.state?.user?.id ||
// //         patientData?.encounterId ||
// //         updatedPatientData?.encounterId;
// //       const shouldCollectConsents =
// //         (!patientData.patientId &&
// //           (patientData.isDropIn || updatedPatientData.isDropIn) &&
// //           (updatedPatientData.selectedStudies || []).length > 0);



// //         {errors.submit && (
// //           <Alert severity="error" sx={{ mt: 2 }}>
// //             {errors.submit}
// //           </Alert>
// //         )}


// // export default GeneralInfo;


// // const GeneralInfo = () => {
// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const { patientData, setPatientData } = usePatient();
// //   const [gender, setGender] = useState("");
// //   const [ethnicity, setEthnicity] = useState("");
// //   const [errors, setErrors] = useState({});
// //   const [isSubmitting, setIsSubmitting] = useState(false);
// //   const [isFormValid, setIsFormValid] = useState(false);

// //   const hasLoadedInitialData = useRef(false);

// //   // Load existing data when component mounts
// //   useEffect(() => {
// //     if (hasLoadedInitialData.current) {
// //       return;
// //     }
// //     hasLoadedInitialData.current = true;

// //     const loadPatientData = async () => {
// //       try {
// //         // Debug: Log what's available in location.state and patientData
// //         console.log("🔍 Location state:", location.state);
// //         console.log("🔍 Patient data from context:", patientData);

// //         // Check if we have prepopulated data from appointment details
// //         if (location.state?.patient) {
// //           const prepopulatedData = location.state.patient;
// //           console.log("🔍 Using prepopulated data:", prepopulatedData);

// //           // Update patient data in context with prepopulated data
// //           setPatientData(prepopulatedData);

// //           // Set form fields from prepopulated data
// //           setGender(prepopulatedData.gender || "");
// //           setEthnicity(prepopulatedData.ethnicity || "");
// //           return;
// //         }

// //         // Fallback to existing logic for API-based data loading
// //         const patientId = location.state?.patientId || patientData?.patientId;
// //         const encounterId =
// //           location.state?.encounterId || patientData?.encounterId;

// //         console.log("🔍 PatientId from state:", patientId);
// //         console.log("🔍 EncounterId from state:", encounterId);

// //         if (patientId) {
// //           console.log("🔍 Fetching patient data for ID:", patientId);

// //           const response = await fetchPatientById(patientId);
// //           console.log("📊 Patient data from API:", response);

// //           if (response) {
// //             setGender(response.gender || "");
// //             setEthnicity(response.ethnicity || "");
// //             setPatientData(response);
// //           }
// //         }
// //       } catch (error) {
// //         console.error("Error loading patient data:", error);
// //       }
// //     };

// //     loadPatientData();
// //   }, [location.state, patientData, setPatientData]);

// //   // Check form validity whenever gender or ethnicity changes
// //   useEffect(() => {
// //     const isValid = gender && ethnicity;
// //     setIsFormValid(isValid);
// //   }, [gender, ethnicity]);

// //   const validateForm = () => {
// //     const newErrors = {};

// //     if (!gender) {
// //       newErrors.gender = "Gender is required";
// //     }
// //     if (!ethnicity) {
// //       newErrors.ethnicity = "Ethnicity is required";
// //     }

// //     setErrors(newErrors);
// //     return Object.keys(newErrors).length === 0;
// //   };

// //   const handleContinue = async () => {
// //     if (!validateForm()) {
// //       return;
// //     }

// //     setIsSubmitting(true);

// //     try {
// //       const updates = {
// //         gender,
// //         ethnicity,
// //         generalInfoComplete: true,
// //       };

// //       let updatedPatientData;
// //       let patientId;

// //       // Check if this is a new patient or existing patient
// //       if (!patientData.patientId) {
// //         // Create new patient
// //         console.log("Creating new patient...");

// //         const newPatientData = {
// //           patientId: uuidv4(),
// //           firstName: patientData.firstName,
// //           lastName: patientData.lastName,
// //           birthDate: patientData.birthDate,
// //           email: patientData.email,
// //           gender,
// //           ethnicity,
// //           patientAccountNumber: patientData.ehrNumber,
// //           orderingPhysician: patientData.orderingPhysician,
// //           selectedStudies: patientData.selectedStudies,
// //           billingAccount: patientData.billingAccount,
// //           isDropIn: patientData.isDropIn || false,
// //           generalInfoComplete: true,
// //         };

// //         console.log("New patient data:", newPatientData);

// //         const createdPatient = await createPatient(newPatientData);
// //         console.log("Patient created successfully:", createdPatient);

// //         patientId = createdPatient.patientId || createdPatient.id;
// //         updatedPatientData = {
// //           ...patientData,
// //           ...createdPatient,
// //           ...updates,
// //         };
// //       } else {
// //         // Update existing patient
// //         console.log("Updating existing patient...");

// //         // Update patient data in context
// //         updatedPatientData = {
// //           ...patientData,
// //           ...updates,
// //         };

// //         console.log("Updating patient data:", updates);

// //         const patientPatchPayload = filterPatientPayload(updates);

// //         if (Object.keys(patientPatchPayload).length > 0) {
// //           await fetchAPI(
// //             `biobank/patients/${patientData.patientId}`,
// //             "PATCH",
// //             {},
// //             patientPatchPayload
// //           );
// //         }

// //         console.log("Patient data updated successfully");
// //         patientId = patientData.patientId;
// //       }

// //       // Update patient data in context
// //       setPatientData(updatedPatientData);

// //       // Decide next step in flow
// //       const encounterId =
// //         location.state?.user?.id ||
// //         patientData?.encounterId ||
// //         updatedPatientData?.encounterId;
// //       const shouldCollectConsents =
// //         (!patientData.patientId &&
// //           (patientData.isDropIn || updatedPatientData.isDropIn) &&
// //           (updatedPatientData.selectedStudies || []).length > 0);



// //         {errors.submit && (
// //           <Alert severity="error" sx={{ mt: 2 }}>
// //             {errors.submit}
// //           </Alert>
// //         )}


// // export default GeneralInfo;


 
// const GeneralInfo = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { patientData, setPatientData } = usePatient();
//   const [gender, setGender] = useState("");
//   const [ethnicity, setEthnicity] = useState("");
//   const [errors, setErrors] = useState({});
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isFormValid, setIsFormValid] = useState(false);
 
//   const hasLoadedInitialData = useRef(false);
 
//   useEffect(() => {
//     if (hasLoadedInitialData.current) return;
//     hasLoadedInitialData.current = true;
 
//     const loadPatientData = async () => {
//       try {
//         console.log("🔍 GeneralInfo - Location state:", location.state);
//         console.log("🔍 GeneralInfo - Context patientData:", patientData);
 
//         const statePatient = location.state?.patient || location.state?.user;
//         if (statePatient && statePatient.patientId) {
//           console.log("🔍 GeneralInfo - Using location.state patient:", statePatient);

//           setPatientData((prev) => ({ ...prev, ...statePatient }));
//           setGender(statePatient.gender || "");
//           setEthnicity(statePatient.ethnicity || "");
//           return;
//         }
 
//         if (patientData?.patientId) {
//           console.log("🔍 GeneralInfo - Prefilling from context:", patientData);
//           setGender(patientData.gender || "");
//           setEthnicity(patientData.ethnicity || "");
//           return;
//         }

//         const patientId = location.state?.patientId;
//         if (patientId) {
//           console.log("🔍 GeneralInfo - Fetching patient from API:", patientId);
//           const response = await fetchPatientById(patientId);
//           console.log("📊 GeneralInfo - API response:", response);
//           if (response) {
//             setPatientData((prev) => ({ ...prev, ...response }));
//             setGender(response.gender || "");
//             setEthnicity(response.ethnicity || "");
//           }
//         }
//       } catch (error) {
//         console.error("GeneralInfo - Error loading patient data:", error);
//       }
//     };
 
//     loadPatientData();
  
//   }, [location.state, patientData, setPatientData]); 
 
//   useEffect(() => {
//     setIsFormValid(!!(gender && ethnicity));
//   }, [gender, ethnicity]);
 
//   const validateForm = () => {
//     const newErrors = {};
//     if (!gender) newErrors.gender = "Gender is required";
//     if (!ethnicity) newErrors.ethnicity = "Ethnicity is required";
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };
 
//   const handleContinue = async () => {
//     if (!validateForm()) return;
//     setIsSubmitting(true);
 
//     try {
//       const updates = {
//         gender,
//         ethnicity,
//         generalInfoComplete: true,
//       };
 
//       let updatedPatientData;
//       let patientId;
 
//       if (!patientData.patientId) {

 
//         const createdPatient = await createPatient(newPatientData);
//         console.log("GeneralInfo - Patient created:", createdPatient);
 
//         patientId = createdPatient.patientId || createdPatient.id;
//         updatedPatientData = { ...patientData, ...createdPatient, ...updates };
//       } else {

//         console.log("GeneralInfo - Updating existing patient...");
//         updatedPatientData = { ...patientData, ...updates };
 
//         const patientPatchPayload = filterPatientPayload(updates);
//         if (Object.keys(patientPatchPayload).length > 0) {
//           await fetchAPI(
//             `biobank/patients/${patientData.patientId}`,
//             "PATCH",
//             {},
//             patientPatchPayload
//           );
//         }
//         patientId = patientData.patientId;
//       }
 
//       setPatientData(updatedPatientData);
 
//       const encounterId =
//         location.state?.encounterId ||
//         patientData?.encounterId ||
//         updatedPatientData?.encounterId;
 
//       const shouldCollectConsents =
//         !patientData.patientId &&
//         (patientData.isDropIn || updatedPatientData.isDropIn) &&
//         (updatedPatientData.selectedStudies || []).length > 0;
 
 
 
//         {errors.submit && (
//           <Alert severity="error" sx={{ mt: 2 }}>
//             {errors.submit}
//           </Alert>
//         )}
 
 
// export default GeneralInfo;
import React, { useEffect, useRef } from "react";
import {
  Box,
  Typography,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Alert,
} from "@mui/material";
import FocusedFlowPage from "components/FocusedFlowPage";
import { Button } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { usePatient } from "./PatientProvider";
import { fetchAPI, fetchPatientById, createPatient } from "utils/api";
import { filterPatientPayload } from "utils/payloadFilters";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { v4 as uuidv4 } from "uuid";
import { GENDER_OPTIONS, ETHNICITY_OPTIONS } from "../../../constants/patientOptions";
import { BIOBANK_ROUTES, BIOBANK_SUB_ROUTES } from "../../../constants/routes";
dayjs.extend(utc);

const GeneralInfo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { patientData, setPatientData, updatePatientData } = usePatient();
  const [gender, setGender] = useState("");
  const [ethnicity, setEthnicity] = useState("");
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  const hasLoadedInitialData = useRef(false);

  useEffect(() => {
    if (hasLoadedInitialData.current) return;
    hasLoadedInitialData.current = true;

    const loadPatientData = async () => {
      try {
        console.log("🔍 GeneralInfo - Location state:", location.state);
        console.log("🔍 GeneralInfo - Context patientData:", patientData);

        // First check: do we already have gender/ethnicity in context (e.g. from back navigation)?
        if (patientData?.gender || patientData?.ethnicity) {
          console.log("🔍 GeneralInfo - Prefilling from context (back nav or sessionStorage)");
          setGender(patientData.gender || "");
          setEthnicity(patientData.ethnicity || "");
        }

        // Merge location.state patient into context if present
        const statePatient = location.state?.patient || location.state?.user;
        if (statePatient && statePatient.patientId) {
          console.log("🔍 GeneralInfo - Merging location.state patient:", statePatient);
          updatePatientData(statePatient);
          // Only override local state if context didn't already have values
          if (!patientData?.gender && statePatient.gender) setGender(statePatient.gender);
          if (!patientData?.ethnicity && statePatient.ethnicity) setEthnicity(statePatient.ethnicity);
          return;
        }

        // If we have a patientId but no gender/ethnicity, fetch from API
        const patientId = patientData?.patientId || location.state?.patientId;
        if (patientId && !patientData?.gender) {
          console.log("🔍 GeneralInfo - Fetching patient from API:", patientId);
          const response = await fetchPatientById(patientId);
          if (response) {
            updatePatientData(response);
            setGender(response.gender || "");
            setEthnicity(response.ethnicity || "");
          }
        }
      } catch (error) {
        console.error("GeneralInfo - Error loading patient data:", error);
      }
    };

    loadPatientData();
  }, [location.state, patientData, setPatientData, updatePatientData]);

  useEffect(() => {
    setIsFormValid(!!gender);
  }, [gender]);

  const validateForm = () => {
    const newErrors = {};
    if (!gender) newErrors.gender = "Gender is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleContinue = async () => {
    if (!validateForm()) return;
    setIsSubmitting(true);

    try {
      const updates = {
        gender,
        ethnicity: ethnicity || undefined,
        generalInfoComplete: true,
      };

      let updatedPatientData;
      let patientId;

      if (!patientData.patientId) {
        // Create new patient
        console.log("GeneralInfo - Creating new patient...");
        const newPatientData = {
          patientId: uuidv4(),
          firstName: patientData.firstName,
          lastName: patientData.lastName,
          birthDate: patientData.birthDate,
          email: patientData.email,
          gender,
          ethnicity: ethnicity || undefined,
          patientAccountNumber: patientData.ehrNumber || patientData.matchedEhr || patientData.ehr || patientData.patientAccountNumber,
          mobilePhoneNumber: patientData.mobilePhoneNumber,
          homeAddressLine1: patientData.homeAddressLine1,
          homeAddressLine2: patientData.homeAddressLine2,
          city: patientData.city,
          state: patientData.state,
          zipCode: patientData.zipCode,
          orderingPhysician: patientData.orderingPhysician,
          selectedStudies: patientData.selectedStudies,
          billingAccount: patientData.billingAccount,
          isDropIn: patientData.isDropIn || false,
          generalInfoComplete: true,
        };

        const createdPatient = await createPatient(newPatientData);
        console.log("GeneralInfo - Patient created:", createdPatient);

        patientId = createdPatient.patientId || createdPatient.id;
        updatedPatientData = { ...patientData, ...createdPatient, ...updates };
      } else {
        // Update existing patient
        console.log("GeneralInfo - Updating existing patient...");
        updatedPatientData = { ...patientData, ...updates };

        const patientPatchPayload = filterPatientPayload(updates);
        if (Object.keys(patientPatchPayload).length > 0) {
          await fetchAPI(
            `biobank/patients/${patientData.patientId}`,
            "PATCH",
            {},
            patientPatchPayload
          );
        }
        patientId = patientData.patientId;
      }

      // Update context (persisted to sessionStorage automatically)
      setPatientData(updatedPatientData);

      const encounterId =
        location.state?.encounterId ||
        patientData?.encounterId ||
        updatedPatientData?.encounterId;

      navigate(BIOBANK_SUB_ROUTES.PARTICIPANT_CHECKIN_WIZARD_FAMILY, {
        state: { patientId, encounterId },
      });
    } catch (error) {
      console.error("GeneralInfo - Error saving patient data:", error);
      setErrors({
        submit: `Failed to ${patientData.patientId ? "update" : "create"} patient data. Please try again.`,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <FocusedFlowPage
      title={
        patientData.patientId
          ? "Update Your Participant Medical Record Number"
          : "Create Your Participant Medical Record Number"
      }
      subtitle={
        patientData.patientId
          ? "Please review and update your basic information for your Texas A&M profile."
          : "Please provide some basic information about yourself to create a Texas A&M profile."
      }
      onClose={() => navigate(BIOBANK_ROUTES.PARTICIPANT_CHECKIN)}
      maxWidth={700}
      actions={[
        <Button
          key="continue"
          variant="contained"
          endIcon={<ArrowForward />}
          onClick={handleContinue}
          disabled={isSubmitting || !isFormValid}
        >
          {isSubmitting
            ? patientData.patientId
              ? "Updating..."
              : "Creating..."
            : "Continue"}
        </Button>,
      ]}
    >
      <Box>
        {errors.submit && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {errors.submit}
          </Alert>
        )}

        <Box sx={{ mt: 3 }}>
          <TextField
            required
            label="First Name"
            variant="outlined"
            fullWidth
            margin="dense"
            value={patientData.firstName || ""}
            InputProps={{ readOnly: true }}
            sx={{ mb: 2 }}
          />
          <TextField
            required
            label="Last Name"
            variant="outlined"
            fullWidth
            margin="dense"
            value={patientData.lastName || ""}
            InputProps={{ readOnly: true }}
            sx={{ mb: 2 }}
          />
          <TextField
            required
            label="Date of Birth"
            variant="outlined"
            fullWidth
            margin="dense"
            type="date"
            value={
              patientData.birthDate
                ? dayjs(patientData.birthDate).utc().format("YYYY-MM-DD")
                : ""
            }
            InputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
            sx={{ mb: 2 }}
          />
          <FormControl
            fullWidth
            margin="dense"
            error={!!errors.gender}
            sx={{ mb: 2 }}
          >
            <InputLabel required>Gender</InputLabel>
            <Select
              labelId="gender-select-label"
              id="gender-select"
              label="Gender"
              value={gender}
              onChange={(e) => setGender(e.target.value)}
            >
              <MenuItem value="" disabled>Select Gender</MenuItem>
              {GENDER_OPTIONS.map(opt => (
                <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
              ))}
            </Select>
            {errors.gender && (
              <Typography variant="caption" color="error" sx={{ mt: 1, ml: 2 }}>
                {errors.gender}
              </Typography>
            )}
          </FormControl>
          <FormControl
            fullWidth
            margin="dense"
            error={!!errors.ethnicity}
            sx={{ mb: 2 }}
          >
            <InputLabel>Ethnicity (Optional)</InputLabel>
            <Select
              labelId="ethnicity-select-label"
              id="ethnicity-select"
              label="Ethnicity (Optional)"
              value={ethnicity}
              onChange={(e) => setEthnicity(e.target.value)}
            >
              <MenuItem value="" disabled>Select Ethnicity</MenuItem>
              {ETHNICITY_OPTIONS.map(opt => (
                <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
              ))}
            </Select>
            {errors.ethnicity && (
              <Typography variant="caption" color="error" sx={{ mt: 1, ml: 2 }}>
                {errors.ethnicity}
              </Typography>
            )}
          </FormControl>
        </Box>
      </Box>
    </FocusedFlowPage>
  );
};

export default GeneralInfo;
